const URL_API = process.env.REACT_APP_API_ROOT_URL || "http://localhost:4066";

const URL_API_88 = process.env.REACT_APP_API_ROOT_URL_88 || "http://localhost:4066";

const URL_MARKETPLACE = process.env.REACT_APP_MARKETPLACE_URL || "http://localhost:5001";

const URL_REALTIME = process.env.REACT_APP_REALTIME_URL || "ws://localhost:4088";

export const BASE_URL = URL_API ;

export const BASE_URL_MARKETPLACE = URL_MARKETPLACE ;

export const BASE_URL_REALTIME = URL_REALTIME;

export const BASE_URL_API = `${URL_API}/api/graphql`;

export const BASE_URL_UPLOAD = `${URL_API}/api/uploadImage`;

export const BASE_URL_UPLOAD_AWS = `${URL_API}/api/uploadImageAWS/admin`;

export const BASE_URL_UPLOAD_AWS_SIGNATURE = `${URL_API}/api/aws/uploadImage`;

export const BASE_URL_UPLOAD_FILE = `${URL_API}/api/uploadFile`;

export const URL_END_POINT = `${URL_API}/api/upload/drug`;

export const BASE_URL_API_NEW = `${URL_MARKETPLACE}/api/graphql`;

export const BASE_URL_API_NEW_88 = `${URL_API_88}/api/graphql`;

export const URL_IMPORT_USER_REMOVE = `${URL_API}/api/upload/importUserRemove`;

export const BIZ_MBS = JSON.parse(process.env.REACT_APP_BIZ_MBS) || [];

export const BIZ_MBS_TEMSTAFF = JSON.parse(process.env.REACT_APP_BIZ_MBS_TEMSTAFF) || [];

export const EXCLUDED_MIGRATE_USER_BUSINESS_ID = JSON.parse(process.env.REACT_APP_EXCLUDED_MIGRATE_USER_BUSINESS_ID) || [];

export const REACT_APP_EXCLUDED_ADD_USER_BUSINESS_ID = JSON.parse(process.env.REACT_APP_EXCLUDED_ADD_USER_BUSINESS_ID) || [];
export const BH_DOMAIN = process.env.REACT_APP_BH_DOMAIN.split(",") || [];
export const HMI_BUSINESS_ID = process.env.REACT_APP_HMI_BUSINESS_ID;

export const AGORA_APPID = process.env.AGORA_APPID || "d06d7e34761b4e9aabb4c23d97353f07";
export const OPENTOK_API_KEY = process.env.OPENTOK_API_KEY || 46738272

export const MPLIFY_BUSINESS_ID = process.env.REACT_APP_MPLIFY_BUSINESS_ID || 26;

export const GROUPCARE_BUSINESS_ID = process.env.REACT_APP_GROUPCARE_BUSINESS_ID || 14;

export const ADMIN_TOPIC = process.env.REACT_APP_ADMIN_TOPIC;

export const COUNSELOR_TOPIC = process.env.REACT_APP_COUNSELOR_TOPIC;

export const DOCTOR_TOPIC = process.env.REACT_APP_DOCTOR_TOPIC;

export const REACT_APP_ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY;
